import throttle from 'lodash.throttle'
import { getPosition, viewport, heightInView } from '../helpers/helpers'
import { TimelineMax } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

export default class ScrollEvents {
	constructor() {

		this.cover = document.querySelector('.home-cover');
		this.stories = document.querySelector('.spanel');
		this.locations = document.querySelector('.locations');
		this.leaders = document.querySelector('.leaders');
		this.numbers = document.querySelector('.numbers');
		this.dues = document.querySelector('.dues');
		this.charts = document.querySelector('.section--charts');
		this.sections = [...document.querySelectorAll('.section')];
		this.accordionCons = [...document.querySelectorAll('.accordions__container')];

		this.threshold = 250; // section needs to be at least [threshold]px in view to animate

		this.init();
		this.events();
	}

	init() {
		if (this.cover) {
			this.coverAnim();
		}

		this.scrollHandle();
	}

	events() {
		this.scrollEventHandler = throttle(this.scrollHandle, 16).bind(this);
		window.addEventListener('scroll', this.scrollEventHandler);

		window.addEventListener('resize', this.scrollHandle.bind(this));
	}

	sectionAnim(section) {
		if (!section.classList.contains('animated')) {
			if ( this.inView(section) ) {
				section.classList.add('animated');

				const title = section.querySelector('.section__title');
				const subtitle = section.querySelector('.section__subtitle');
				const intro = section.querySelector('.section__intro');
				const dlBtn = section.querySelector('.dl__btn');

				const allComps = [title, subtitle, intro, dlBtn].filter(el => el);

				let sectionTl = new TimelineMax({
					delay: 0.3
				});

				if (allComps.length > 0) {
					sectionTl.staggerFrom(allComps, 0.6, { ease: Power2.easeOut, alpha: 0, cycle: {
						y: i => 20 + i*10
					}}, 0.1);
				}
			}
		}
	}

	// cover animation
	coverAnim() {
		if (document.querySelector('.home-cover__title')) {
			const title = this.cover.querySelector('.home-cover__title');
			const titleLines = [...title.querySelectorAll('.home-cover__title-line')];
			const reportToggle = this.cover.querySelector('.report-toggle');
			const bg = this.cover.querySelector('.home-cover__bg');
	
			let coverTl = new TimelineMax({
				delay: 0.1,
				onStart: () => {
					this.cover.classList.remove('waiting');
				}
			});
	
			coverTl
			.from(bg, 2, { ease: Power2.easeInOut, scale: 1.2, alpha: 0 })
			.staggerFrom(titleLines, 2, { ease: Expo.easeInOut, y: '100%', alpha: 0 }, 0.1, 0)
			.from(reportToggle, 1, { ease: Power2.easeInOut, alpha: 0, x: 20 }, 1.2);
		}
	}

	// stories panel animation
	storiesAnim() {
		if ( this.inView(this.stories) ) {

			this.storiesAnimated = true;
			const sTiles = [...this.stories.querySelectorAll('.stile')];
			const container = this.stories.querySelector('.spanel__container');

			let storiesTl = new TimelineMax({
				delay: 0.3,
				onStart: () => {
					container.classList.remove('waiting');
				}
			});

			storiesTl
			.staggerFrom(sTiles, 1, { ease: Power3.easeOut, alpha: 0, cycle: {
				rotationX: i => -5 - i*3,
				// rotationY: i => -3 - i*2
			}}, 0.15);
		}
	}

	// locations panel animation
	locationsAnim() {
		if ( this.inView(this.locations) ) {

			this.locationsAnimated = true;
			const elems = [...this.locations.querySelectorAll('.location:not(.location--empty)')];
			const list = this.locations.querySelector('.locations__list');

			let locationsTl = new TimelineMax({
				delay: 0.3,
				onStart: () => {
					list.classList.remove('waiting');
				}
			});

			locationsTl
			.staggerFrom(elems, 1, { ease: Power2.easeOut, rotationY: -10, z: 30, alpha: 0, cycle: {
				rotationX: i => -20 - i*1.5
			}}, 0.04);

		}
	}

	// numbers panel animation
	numbersAnim() {
		if ( this.inView(this.numbers) ) {

			this.numbersAnimated = true;
			const container = this.numbers.querySelector('.numbers__container');

			let numbersTl = new TimelineMax({
				delay: 0.4,
				onStart: () => {
					container.classList.remove('waiting');
				}
			});

			numbersTl
			.from(container, 1.5, { ease: Power3.easeOut, alpha: 0, y: 50 });

		}
	}

	// leaders panel animation
	leadersAnim() {
		if ( this.inView(this.leaders) ) {

			this.leadersAnimated = true;
			const container = this.leaders.querySelector('.leaders__container');

			let leadersTl = new TimelineMax({
				delay: 0.4,
				onStart: () => {
					container.classList.remove('waiting');
				}
			});

			leadersTl
			.from(container, 1.5, { ease: Power3.easeOut, alpha: 0, y: 50 });

		}
	}

	// dues panel animation
	duesAnim() {
		if ( this.inView(this.dues) ) {

			this.duesAnimated = true;
			const circles = [...this.dues.querySelectorAll('.ditem__graphic__circle')];
			const lines = [...this.dues.querySelectorAll('.ditem__graphic__line')];
			const copyCons = [...this.dues.querySelectorAll('.ditem__copy')];
			const container = this.dues.querySelector('.dues__container');

			let duesTl = new TimelineMax({
				delay: 0.3,
				onStart: () => {
					container.classList.remove('waiting--desk');
				}
			});

			duesTl
			.staggerFrom(lines, 1, { ease: Power4.easeInOut, scaleX: 0, transformOrigin: '100% 0%' }, 0.05)
			.staggerFrom(circles, 1, { ease: Elastic.easeOut.config(0.5, 0.3), scale: 0, x: 40 }, 0.05, 0.5)
			.staggerFrom(copyCons, 1, { ease: Power3.easeInOut, alpha: 0, x: -20 }, 0.05, 0.1)


		}
	}
	
	chartsAnim(){
		if (this.inView(this.charts)) {
			this.chartsAnimated = true;
			App.Charts.reveal();
		}
	}

	// dues panel mobile animation
	duesAnimMobile() {
		if ( this.inView(this.dues) ) {

			this.duesAnimatedMobile = true;
			const bars = [...this.dues.querySelectorAll('.ditem__bar')];
			const percents = [...this.dues.querySelectorAll('.ditem__bar-percent')];
			const names = [...this.dues.querySelectorAll('.ditem__name')];
			const container = this.dues.querySelector('.dues__container');

			let duesTlM = new TimelineMax({
				delay: 0.3,
				onStart: () => {
					container.classList.remove('waiting--mobile');
				}
			});

			duesTlM
			.from(container, 0.3, { ease: Power3.easeOut, alpha: 0 })
			.staggerFrom(bars, 1, { ease: Power4.easeInOut, transformOrigin: '0% 50%', scaleX: 0 }, 0.1, 0.2)
			.staggerFrom(percents, 1, { ease: Power3.easeInOut, alpha: 0, x: -20 }, 0.1, 0.3)
			.staggerFrom(names, 1, { ease: Power3.easeInOut, alpha: 0, clearProps: 'all' }, 0.1, 0.4)
		}
	}

	// accordion animation
	accordionAnim(con) {
		if (con.classList.contains('waiting')) {
			if (this.inView(con)) {
				con.classList.remove('waiting');

				const accordions = [...con.querySelectorAll('.accordion')];

				let accordionTl = new TimelineMax({
					// delay: 0.3
				});

				accordionTl
				.staggerFrom(accordions, 1.5, { ease: Power3.easeInOut, alpha: 0, cycle: {
					y: i => 30 + i*10
				}}, 0.05);
			}
		}
	}


	scrollHandle() {

		if (this.stories && !this.storiesAnimated) {
			this.storiesAnim();
		}

		if (this.locations && !this.locationsAnimated) {
			this.locationsAnim();
		}

		if (this.leaders && !this.leadersAnimated) {
			this.leadersAnim();
		}

		if (this.numbers && !this.numbersAnimated) {
			this.numbersAnim();
		}

		if (this.dues && !this.duesAnimated && viewport().width > 640) {
			this.duesAnim();
		}

		if (this.charts && !this.chartsAnimated) {
			this.chartsAnim();
		}

		if (this.dues && !this.duesAnimatedMobile && viewport().width <= 640) {
			this.duesAnimMobile();
		}

		if (this.accordionCons) {
			this.accordionCons.forEach(con => {
				this.accordionAnim(con);
			});
		}

		if (this.sections) {
			this.sections.forEach(section => {
				this.sectionAnim(section);
			});
		}
	}

	inView(section) {
		return heightInView(section) >= Math.min(this.threshold, section.getBoundingClientRect().height);
	}

}